import { Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useDateUtils, validateRuppes } from "../../../utils/formatTime";

export default function PaymentComp({
  SelectedData,
  selectedFilter,

  monthName,
  selectedYear,
  fromDate,
  toDate,
  countryId
}) {
  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => {
        // Get all row IDs in sorted order
        const allRowIds = params.api.getSortedRowIds();

        // Get the last row ID
        const lastRowId = allRowIds[allRowIds.length - 1];

        // Check if the current row is the last row
        const isLastRow = params.id === lastRowId;

        return (
          <div
            style={{
              color: isLastRow ? "black" : "#0096FF",
              fontWeight: isLastRow ? "bold" : "normal",
              cursor: "pointer",
            }}
            onClick={() =>
              !isLastRow
                ? window.open(
                    `/enquirydetails/${params?.row.enquiry_id.id}`,
                    "_blank"
                  )
                : undefined
            }
          >
            {params?.row?.enquiry_id?.first_name || ""}{" "}
            {params?.row?.enquiry_id?.last_name || ""}
          </div>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => <div>{params?.row?.enquiry_id?.mobile}</div>,
    },
    {
      field: "amount_paid",
  headerName: `Amount ${countryId ? `(${validateRuppes(countryId)})` : ""}`,
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
    },

    {
      field: "collected_by",
      headerName: "Collected By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.collected_by?.mobile || "",
      renderCell: (params) => (
        <div>
          {" "}
          {params?.row?.collected_by?.first_name}{" "}
          {params?.row?.collected_by?.last_name}
        </div>
      ),
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
    },

    {
      field: "branch",
      headerName: "Branch",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.branch_id?.branch_name || "",
      renderCell: (params) => <div>{params?.row?.branch_id?.branch_name}</div>,
    },
    {
      field: "payment_date",
      headerName: "Payment  Date",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
    },

    {
      field: "payment_mode_id",
      headerName: "Payment Mode",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.payment_mode_id?.payment_mode || "",
      renderCell: (params) => (
        <div>{params?.row?.payment_mode_id?.payment_mode}</div>
      ),
    },

    {
      field: "collected_status",
      headerName: "Collected Status",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
    },

    {
      field: "approved_by",
      headerName: "Approved By/Declined By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",

      renderCell: (params) => (
        <div>
          {params?.row?.collected_status === "confirmed"
            ? `${params?.row?.approved_by?.first_name || ""} ${
                params?.row?.approved_by?.last_name || ""
              }`
            : params?.row?.collected_status === "declined"
            ? `${params?.row?.declined_by?.first_name} ${params?.row?.declined_by?.last_name}`
            : ""}
        </div>
      ),
    },
    {
      field: "declined_date",
      headerName: "Approved Date/Declined Date",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params.row?.collected_status === "confirmed"
            ? params?.row?.verified_date
            : params.row?.collected_status === "declined"
            ? params?.row?.declined_date
            : ""}
        </div>
      ),
    },
    {
      field: "declined_remarks",
      headerName: "Declined Remarks",
      flex: 1,
      minWidth: 350,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row?.collected_status === "declined"
            ? params?.row?.declined_remarks
            : ""}
        </div>
      ),
    },
  ];

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Initial page
    pageSize: 25, // Initial page size
  });

  const isLastRowOnCurrentPage = () => {
    const totalRows = SelectedData.length;
    const { page, pageSize } = paginationModel;

    // Calculate the range of indexes for the current page
    const startIndex = page * pageSize;
    const endIndex = startIndex + pageSize - 1;

    return totalRows - 1 >= startIndex && totalRows - 1 <= endIndex;
  };

  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {selectedFilter === "default" && (
            <Typography variant="h4" textAlign="center">
              {monthName} {selectedYear}
            </Typography>
          )}
          {selectedFilter === "today" && (
            <Typography variant="h4" textAlign="center">
              Today ({currentDate})
            </Typography>
          )}
          {selectedFilter === "currentweek" && (
            <Typography variant="h4" textAlign="center">
              This Week ({weekRange})
            </Typography>
          )}

          {selectedFilter === "currentmonth" && (
            <Typography variant="h4" textAlign="center">
              {currentMonthName} {currentYear}
            </Typography>
          )}

          {selectedFilter === "custom" && (
            <Typography variant="h4" textAlign="center">
              {fromDate} - {toDate}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={SelectedData}
            columns={columns}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
             paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
            getRowClassName={(params) =>
              isLastRowOnCurrentPage() &&
              params.id === SelectedData[SelectedData.length - 1].id
                ? "last-row"
                : ""
            }
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
